<template>
  <div class="pointer" v-if="inviteFriends.length == 0">
    {{ $t('envelope.inviteFriends') }} {{ $t('envelope.cash') }}
  </div>
  <div class="pointer-height" v-else-if="depositCollected.length == 0">
    {{ $t('envelope.inviteRegister') }}
  </div>
  <div class="pointer-height" v-else>{{ $t('envelope.depositbyFriends') }}</div>
  <div class="invite-share">
    <div
      class="invite-icon"
      v-for="(item, index) in inviteIcon"
      :key="index"
      @click="onShare(item)"
    >
      <img class="invite-img" :src="item.url" alt="" />
      <div class="invite-name" :style="`margin-left:-${item.offX}rem;color:${item.color}`">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    inviteIcon: {
      type: Array,
      default: () => []
    },
    inviteFriends: {
      type: Array,
      default: () => []
    },
    depositCollected: {
      type: Array,
      default: () => []
    },
    onShare: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-title {
  width: 100%;
  height: auto;
  font-family: Droid Sans;
  font-weight: 400;
  font-size: 0.24rem;
  color: #000000;
  line-height: 0.4rem;
  // margin-left: 1.52rem;
  margin-top: 0.3rem;
  text-align: center;
}

.pointer {
  font-family: 'Droid Sans', Roboto, Arial, sans-serif;
  font-size: 0.24rem;
  color: #fff;
  line-height: 0.5rem;
  text-align: center;
  width: 90%;
  margin-left: 5%;
  height: 0.5rem;
  position: relative;
  background: #d51212;
  margin-top: 0.4rem;
}

.pointer:after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: 0;
  width: 0;
  height: 0;
  border-left: 0.25rem solid #f1f1f1;
  border-top: 0.25rem solid transparent;
  border-bottom: 0.25rem solid transparent;
}

.pointer:before {
  content: '';
  position: absolute;
  right: -1px;
  bottom: 0;
  width: 0;
  height: 0;
  border-right: 0.25rem solid #f1f1f1;
  border-top: 0.25rem solid transparent;
  border-bottom: 0.25rem solid transparent;
}

.pointer-height {
  font-family: 'Droid Sans', Roboto, Arial, sans-serif;
  font-size: 0.24rem;
  color: #fff;
  line-height: 0.35rem;
  text-align: center;
  width: 90%;
  margin-left: 5%;
  height: 0.7rem;
  position: relative;
  background: #d51212;
  margin-top: 0.4rem;
}

.pointer-height:after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: 0;
  width: 0;
  height: 0;
  border-left: 0.2rem solid #f1f1f1;
  border-top: 0.35rem solid transparent;
  border-bottom: 0.35rem solid transparent;
}

.pointer-height:before {
  content: '';
  position: absolute;
  right: -1px;
  bottom: 0;
  width: 0;
  height: 0;
  border-right: 0.2rem solid #f1f1f1;
  border-top: 0.35rem solid transparent;
  border-bottom: 0.35rem solid transparent;
}

.invite-share {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 0.1rem;
  margin-bottom: 0.5rem;
  width: auto;

  .invite-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 0.8rem;

    .invite-img {
      width: 0.8rem;
      height: 0.8rem;
    }

    .invite-name {
      width: auto;
      height: 0.25rem;
      font-family: Droid Sans;
      font-weight: 400;
      font-size: 0.24rem;
      color: #9ca0ab;
      line-height: 0.4rem;
      text-align: center;
    }
  }
}
</style>
